var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.621,
    height: 16,
    viewBox: "0 0 24.621 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(-290.795 -346.65)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M293.87,442.81v1.2h-1.214V442.8h-1.844c-.006-.134-.015-.228-.015-.321,0-1.1,0-2.193,0-3.29a4.3,4.3,0,0,1,4.4-4.391q7.908-.006,15.815,0a4.29,4.29,0,0,1,4.4,4.363c0,1.116,0,2.232,0,3.348,0,.084-.009.168-.015.282h-1.823v1.221h-1.224v-1.2Z",
    transform: "translate(0 -81.356)",
    fill: "#3fbbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M342.377,352.679a5.685,5.685,0,0,0-3.047-.484,1.1,1.1,0,0,1-.04-.149,1.821,1.821,0,0,0-1.829-1.692c-1.24-.022-2.481-.009-3.721,0a1.87,1.87,0,0,0-1.211.465,2.493,2.493,0,0,0-1.844-.472c-.923.011-1.848.034-2.769-.005a1.952,1.952,0,0,0-2.181,1.853,5.72,5.72,0,0,0-3.045.485c-.008-.134-.018-.216-.018-.3,0-.837,0-1.673,0-2.51a3.085,3.085,0,0,1,3.218-3.214q5.222-.008,10.444,0c.962,0,1.923-.007,2.885,0a3.076,3.076,0,0,1,3.089,2.437,2.6,2.6,0,0,1,.066.543C342.38,350.624,342.377,351.614,342.377,352.679Z",
    transform: "translate(-29.422)",
    fill: "#3fbbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M464.124,411.407h-4.879a.533.533,0,0,1,.59-.588c.7-.009,1.4,0,2.1,0,.509,0,1.018,0,1.527,0C463.85,410.825,464.03,410.983,464.124,411.407Z",
    transform: "translate(-155.484 -59.226)",
    fill: "#3fbbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M383.872,411.406h-4.88c.043-.373.223-.579.562-.582q1.872-.015,3.745,0C383.63,410.826,383.829,411.043,383.872,411.406Z",
    transform: "translate(-81.409 -59.228)",
    fill: "#3fbbae"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedIcon);
export default __webpack_public_path__ + "static/media/bedIcon.6a6003dfa9db681fe8b7325244bc76fa.svg";
export { ForwardRef as ReactComponent };